import type { DrawerItemType } from '@gower/react-ui/template/drawer';

export enum RoutesEnum {
    Base = '/',
    Home = '/privacy',
}